import { render } from "./Hero.vue?vue&type=template&id=7060b4a0&scoped=true&ts=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=7060b4a0&lang=scss&scoped=true"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7060b4a0"]])

export default __exports__